<template>
  <div class="sign-up-partner">
    <div class="sign-up-partner__content">
      <vs-row vs-align="stretch">
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
          <img 
           class="sign-up-partner__content-banner"
           :src="imgBanner" />
          <slot v-if="!isDesktop" />
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useStore } from "@/store/store.js"
import imgBannerDesktop from '@/assets/banner-checkout.png'
import imgBannerMobile from '@/assets/banner-mobile.png'

export default defineComponent({
  name: "SignUpHeader",

  setup () {
    const store = useStore()

    return {
      isDesktop: computed(() => store.getters.isDesktop)
    }
  },

  computed: {
    imgBanner () {
      return this.isDesktop ? imgBannerDesktop : imgBannerMobile
    }
  }
})
</script>

<style lang="scss" scoped>
.sign-up-partner {
  $this: &;

  &__content {
    align-items: center;
    display: inline-flex;
    gap: 1rem;
    justify-content: center;
    width: 100%;

    @media #{$md-and-up} {
      gap: 2rem;
    }

    &-banner {
      border-radius: .5rem;
      display: block;
      width: 100%;
      height: 100%;

      @media (max-width: 768px) {
        background-size: contain;
        height: auto;
      }
    }
  }
}
</style>
